(() => {
  angular
    .module('app')
    .controller('host.views.panelRecruitment.panelRequest', PanelRequestController);

  PanelRequestController.$inject = ['$stateParams', 'abp.services.app.panelRequest'];

  function PanelRequestController($stateParams, panelRequestSvc) {
    const vm = this;

    vm.loading = 0;
    vm.requestNumber = $stateParams.requestNumber;
    vm.panelRequestEditModel = null;
    vm.isEdit = false;
    vm.panelName = '';

    vm.getPanelRequestForEdit = getPanelRequestForEdit;

    activate();

    function activate() {
      getPanelRequestForEdit();
    }

    function getPanelRequestForEdit() {
      panelRequestSvc
        .getPanelRequestForEdit({
          id: vm.requestNumber,
        })
        .success((data) => {
          if (data) {
            vm.panelRequestEditModel = data;
            vm.requestNumber = data.request.requestNumber;
            vm.panelName = data.request.panelName;
          }
        });
    }
  }
})();
